import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAg7gg8rVF7kgFkTc7LBAg9LmchEZmBq6A",
  authDomain: "veritas-image.firebaseapp.com",
  projectId: "veritas-image",
  storageBucket: "veritas-image.firebasestorage.app",
  messagingSenderId: "125254683182",
  appId: "1:125254683182:web:ac2612628cdb62411aadbf",
  measurementId: "G-XXLCM2S1T5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser, not in SSR)
let analytics;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn('[Firebase] Analytics initialization failed:', e);
  }
}

export const auth = getAuth(app);

// Initialize Firestore with settings
export const db = getFirestore(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Log Firebase initialization
console.log('[Firebase] Initialized:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  hasDb: !!db,
  hasAuth: !!auth,
  hasStorage: !!storage
});

export default app;
